import { TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import * as React from 'react';
import { Button, Card, CardBottom, CardContent, CardTop, EqualHeight, Grid, GridColumn, Heading, Icon, InternetSpeedIndicator, Separator, Text, useAnalytics } from 'telia-front-react';
import { Telia1Image } from '../common/Telia1Image';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { resolveIndicatorValue } from '../util/InternetCalculatorUtil';
import { resolveOfferCardProps, resolveOfferTag } from '../util/InternetOfferUtil';
import InternetOfferButtons from './InternetOfferButtons';
import InternetOfferCharacteristics from './InternetOfferCharacteristics';
import InternetOfferPrice from './InternetOfferPrice';
import CampaignButtons from './CampaignButtons';
const InternetOfferCard = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const { isRecommended, offer, inModal, inForm, hideButtons, suggestedInternet } = props;
    const { internetCalculatorConfigState, setModalState } = useInternetCalculator();
    const { isMobile } = useIsMobileHook();
    const { push } = useAnalytics();
    const { translate } = React.useContext(TranslationsContext);
    const isSuggested = offer.productOfferingCode === suggestedInternet;
    const isBaseConnection = offer.properties.includes('BASE_CONNECTION');
    const cardSpeedIndicatorValue = (_a = offer.speedIndicatorValue) !== null && _a !== void 0 ? _a : resolveIndicatorValue((_b = internetCalculatorConfigState.config) === null || _b === void 0 ? void 0 : _b.speedIndicatorValues, +offer.downloadSpeed);
    const campaignTagFromWpConf = (_e = (_d = (_c = internetCalculatorConfigState.config) === null || _c === void 0 ? void 0 : _c.campaigns) === null || _d === void 0 ? void 0 : _d.filter((c) => !!offer.discounts && offer.discounts.length !== 0 && c.code === offer.discounts[0].campaignCode)[0]) === null || _e === void 0 ? void 0 : _e.tag;
    const showCampaignTag = ((_f = offer.discounts) === null || _f === void 0 ? void 0 : _f.length) !== 0 && !inModal && !!((campaignTagFromWpConf === null || campaignTagFromWpConf === void 0 ? void 0 : campaignTagFromWpConf.text) || (campaignTagFromWpConf === null || campaignTagFromWpConf === void 0 ? void 0 : campaignTagFromWpConf.icon));
    const getTelia1SpeedIndicator = () => (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "text-tiny text-primary" },
            React.createElement(Separator, { color: "invisible", spacing: isMobile ? 'xsmall' : 'small' }),
            translate('internetCalculator.downloadSpeedTitle.telia1')),
        React.createElement("p", { className: "text-tiny text-primary" },
            React.createElement("span", { className: "h3" },
                offer.downloadSpeed,
                " ",
                translate('internetCalculator.downloadSpeedUnit'))),
        React.createElement("p", { className: "text-tiny text-primary" },
            translate('internetCalculator.uploadSpeedTitle'),
            ' ',
            React.createElement("strong", null,
                offer.uploadSpeed,
                " ",
                translate('internetCalculator.uploadSpeedUnit'))),
        React.createElement(Separator, { weight: "thin", spacing: "xxsmall" }),
        React.createElement("p", { className: "text-tiny c-neutral-text-subtle" },
            translate('internetCalculator.regularSpeedSummary'),
            React.createElement("br", null),
            " ",
            offer.contractualDownloadSpeed,
            "/",
            offer.contractualUploadSpeed,
            " ",
            translate('internetCalculator.downloadSpeedUnit'))));
    const renderSpeedIndicator = () => {
        const indicatorBaseProps = {
            id: `internet-speed-indicator-${offer.productOfferingCode}`,
            size: 'responsive',
            value: cardSpeedIndicatorValue
        };
        return offer.properties.includes('TELIA1') ? (React.createElement(InternetSpeedIndicator, { ...indicatorBaseProps }, getTelia1SpeedIndicator())) : (React.createElement(InternetSpeedIndicator, { ...indicatorBaseProps, down: {
                title: translate('internetCalculator.downloadSpeedTitle'),
                speed: offer.downloadSpeed,
                unit: translate('internetCalculator.downloadSpeedUnit')
            }, up: {
                title: translate('internetCalculator.uploadSpeedTitle'),
                speed: offer.uploadSpeed,
                unit: translate('internetCalculator.uploadSpeedUnit')
            } }));
    };
    const renderButtons = () => {
        return !hideButtons ? (React.createElement(CardContent, { padding: { top: 'none' } },
            React.createElement(CardBottom, null,
                inModal && React.createElement(CampaignButtons, { showTelia1CampaignButton: offer.properties.includes('TELIA1') }),
                React.createElement(InternetOfferButtons, { offer: offer, inModal: inModal })))) : null;
    };
    const renderTelia1Banner = () => {
        return (React.createElement(CardContent, { padding: {
                top: 'small',
                left: 'medium',
                right: 'medium',
                bottom: 'small'
            } },
            React.createElement(Grid, { horizontalGutter: "small", align: ['middle-xs'], noWrap: true },
                React.createElement(GridColumn, { width: ['min'] },
                    React.createElement(Telia1Image, { imageWidth: 48 })),
                React.createElement(GridColumn, { width: ['max'] },
                    React.createElement(Button, { link: true, text: translate('internetCalculator.telia1PromoTitle.speed'), onClick: () => {
                            push(`Link - Telia1 Modal - ${offer.productOfferingCode}`);
                            setModalState({ offer, showForm: false, showTelia1PromoModal: true });
                        } })))));
    };
    const renderBaseConnectionTitle = () => {
        return (React.createElement(Text, { className: "text-center" },
            React.createElement(Grid, null,
                React.createElement(GridColumn, null,
                    React.createElement(Icon, { modifiers: '#service-internet', size: "lg" })),
                React.createElement(GridColumn, null,
                    React.createElement(Heading, { level: 3 }, translate('internetCalculator.BASE_CONNECTION_OFFER'))))));
    };
    const renderSpeedIndicatorInContent = () => {
        return (React.createElement(CardContent, { tagTop: resolveOfferTag(offer, translate, isRecommended, isSuggested) },
            React.createElement(EqualHeight, { group: "speed-indicator", align: "middle" }, isBaseConnection ? renderBaseConnectionTitle() : renderSpeedIndicator())));
    };
    const renderPrices = () => {
        if (isBaseConnection) {
            return React.createElement(Separator, { color: "invisible", spacing: "medium" });
        }
        return (React.createElement(EqualHeight, { group: "price", align: "top" },
            React.createElement(CardContent, { padding: { top: 'none', bottom: 'none' } },
                React.createElement(CardTop, null,
                    React.createElement(InternetOfferPrice, { offer: offer, inModal: inModal })))));
    };
    const renderOfferCharacteristics = () => {
        return (React.createElement(CardContent, { padding: { top: 'none', bottom: inForm ? 'small' : 'none' } },
            React.createElement(CardTop, null,
                React.createElement(InternetOfferCharacteristics, { offer: offer, inForm: inForm }))));
    };
    const renderTelia1CardContent = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(EqualHeight, { group: "card-text" },
                renderSpeedIndicatorInContent(),
                React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
                renderTelia1Banner(),
                React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }),
                renderOfferCharacteristics()),
            renderCardContentFooter()));
    };
    const renderRegularCardContent = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(EqualHeight, { group: "card-text" },
                renderSpeedIndicatorInContent(),
                renderOfferCharacteristics()),
            renderCardContentFooter()));
    };
    const renderCardContentFooter = () => {
        return (React.createElement(EqualHeight, { group: "card-footer" },
            renderPrices(),
            renderButtons()));
    };
    return (React.createElement(Card, { ...resolveOfferCardProps(isRecommended, isSuggested, inModal, offer.properties), tag: showCampaignTag && { text: translate(campaignTagFromWpConf.text), icon: campaignTagFromWpConf.icon, purpose: 'campaign-3' }, padding: isMobile ? 'small' : 'medium' }, offer.properties.includes('TELIA1') ? renderTelia1CardContent() : renderRegularCardContent()));
};
export default InternetOfferCard;
